import { ConfidenceMetric, Training } from '../../store/store.types'

export const getConfidence = (training?: Training) => {
  const confidenceMetrics = training?.metrics.filter(
    (m) => m.schemaType === 'confidence'
  )

  const confidenceMetric =
    confidenceMetrics && (confidenceMetrics[0] as ConfidenceMetric)

  const confidenceValue = confidenceMetric?.data

  return confidenceValue
}
